// Deterministic avatar color + initial for a user, à la Google Chat.
// Same uid → same color forever.

const PALETTE = [
  "#1a73e8", // blue
  "#34a853", // green
  "#ea4335", // red
  "#f9ab00", // amber
  "#9334e6", // purple
  "#e91e63", // pink
  "#0097a7", // teal
  "#5f6368", // grey
  "#1e8e3e", // emerald
  "#d93025", // crimson
];

export function avatarColor(uid) {
  if (!uid) return PALETTE[7];
  let hash = 0;
  for (let i = 0; i < uid.length; i++) {
    hash = ((hash << 5) - hash + uid.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

export function avatarInitial(name) {
  if (!name) return "?";
  // Use the first letter of the first non-empty word.
  const trimmed = String(name).trim();
  if (!trimmed) return "?";
  const first = trimmed.split(/\s+/)[0];
  return first.charAt(0).toUpperCase();
}
